let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("196Yj")).then(() => parcelRequire('2NH74'));